interface DeviceInfo {
    deviceId: string
    deviceOs?: string
    deviceName?: string
    deviceType?: string
    browserInfo?: string
    isMobile?: boolean
}

/**
 * 获取设备操作系统信息
 */
function getOperatingSystem(userAgent: string): string {
    const os = {
        Windows: /Windows/i,
        MacOS: /Macintosh|Mac OS X/i,
        Linux: /Linux/i,
        iOS: /iPhone|iPad|iPod/i,
        Android: /Android/i,
    }

    for (const [key, value] of Object.entries(os)) {
        if (value.test(userAgent)) {
            return key
        }
    }

    return 'Unknown OS'
}

/**
 * 获取浏览器信息
 */
function getBrowserInfo(userAgent: string): string {
    const browsers = {
        Chrome: /Chrome/i,
        Firefox: /Firefox/i,
        Safari: /Safari/i,
        Edge: /Edge/i,
        IE: /MSIE|Trident/i,
    }

    for (const [key, value] of Object.entries(browsers)) {
        if (value.test(userAgent)) {
            return key
        }
    }

    return 'Unknown Browser'
}

/**
 * 获取设备类型
 */
function getDeviceType(userAgent: string): string {
    if (/Mobile|Android|iPhone|iPad|iPod/i.test(userAgent)) {
        return 'Mobile'
    }
    if (/Tablet|iPad/i.test(userAgent)) {
        return 'Tablet'
    }
    return 'Desktop'
}

/**
 * 获取设备名称
 */
function getDeviceName(userAgent: string): string {
    const devicePatterns = {
        iPhone: /iPhone/i,
        iPad: /iPad/i,
        iPod: /iPod/i,
        MacBook: /Macintosh/i,
        WindowsPC: /Windows/i,
        AndroidDevice: /Android/i,
    }

    for (const [key, value] of Object.entries(devicePatterns)) {
        if (value.test(userAgent)) {
            return key
        }
    }

    return 'Unknown Device'
}

/**
 * 获取完整的设备信息
 */
export function getDeviceInfo(): DeviceInfo | null {
    let deviceId = ''

    // 优先从 nuxtApp 上下文读取（插件中已设置）
    try {
        const nuxtApp = useNuxtApp()
        deviceId = (nuxtApp.$deviceId as string) || ''
    } catch (error) {
        console.log(JSON.stringify(error), '无法从 nuxtApp 读取 deviceId，尝试从 cookie 读取')
    }

    // 如果上下文中没有，尝试从 cookie 读取
    if (!deviceId) {
        const deviceIdCookie = useCookie('deviceId')
        deviceId = deviceIdCookie.value || ''
    }

    if (!import.meta.client) {
        return {
            deviceId,
        }
    }

    const userAgent = navigator.userAgent
    return {
        deviceId,
        deviceOs: getOperatingSystem(userAgent),
        deviceName: getDeviceName(userAgent),
        deviceType: getDeviceType(userAgent),
        browserInfo: getBrowserInfo(userAgent),
        isMobile: /Mobile|Android|iPhone|iPad|iPod/i.test(userAgent),
    }
}

/**
 * 获取设备信息的请求头
 */
export function getDeviceHeaders(): Record<string, string> {
    const deviceInfo = getDeviceInfo()
    if (!deviceInfo) {
        return {}
    }

    return {
        'seame-device-id': deviceInfo.deviceId,
        'seame-device-os': deviceInfo.deviceOs || '',
        'seame-device-name': deviceInfo.deviceName || '',
        // 'seame-device-type': deviceInfo.deviceType,
        // 'seame-browser-info': deviceInfo.browserInfo,
    }
}

export default {
    getDeviceInfo,
    getDeviceHeaders,
}
